import { RefObject, useEffect, useRef } from 'react';

function useFixedScrollPositionOnPageChange(parentRef: RefObject<any>) {
  const scrollPositionRef = useRef<number>(0);

  useEffect(() => {
    parentRef.current.scrollTo(0, scrollPositionRef.current);
  });

  useEffect(() => {
    const parent = parentRef.current;

    const handleScroll = () => {
      scrollPositionRef.current = parent?.scrollTop;
    };

    parent?.addEventListener('scroll', handleScroll);

    return () => parent?.removeEventListener('scroll', handleScroll);
  }, [parentRef]);
}

export default useFixedScrollPositionOnPageChange;
